import { useLocation } from "react-router-dom-v5-compat";

import { shouldShowChatFab } from "../shared/HelpButton/chatFabRoutes";
import { HtsAssistChatWidget } from "./HtsAssistChatWidget";
import { HtsAssistChatWidgetErrorBoundary } from "./HtsAssistChatWidgetErrorBoundary";
import { useIsHtsAssistEnabled } from "./useIsHtsAssistEnabled";

// Thin mount gate kept separate from HtsAssistChatWidget so the
// HtsAssistEnabled check can be unit tested without having to render (or
// mock) the full chat widget tree.
//
// Only mounted where the Help FAB that opens Assist is offered: the widget
// portals a full-viewport root to document.body, so on a route with no FAB it
// sat invisibly over the booking funnel and swallowed clicks (ASSIST-821).
export const HtsAssistChatWidgetGate: React.FC = () => {
  const isEnabled = useIsHtsAssistEnabled();
  const location = useLocation();

  if (!isEnabled || !shouldShowChatFab(location.pathname)) {
    return null;
  }

  return (
    <HtsAssistChatWidgetErrorBoundary>
      <HtsAssistChatWidget />
    </HtsAssistChatWidgetErrorBoundary>
  );
};
